<script>
import SvgIcon from '@/components/SvgIcon/index.vue' // 路径根据实际情况调整

export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render(h, context) {
    const { icon, title } = context.props
    const vnodes = []
    if (icon) {
      if (icon.includes('el-icon')) {
        vnodes.push(h('i', { class: [icon, 'sub-el-icon'] }))
      } else {
        vnodes.push(h(SvgIcon, { props: { iconClass: icon }}))
      }
    }
    if (title) {
      vnodes.push(h('span', title))
    }
    return h('span', vnodes)
  }
}
</script>

<style scoped>
.sub-el-icon {
  color: currentColor;
  width: 1em;
  height: 1em;
}
</style>
